import { useEffect } from 'react'
import { applyGlobalStyles } from '@minicoursegenerator/wait-screen'

let stylesApplied = false
let activeConsumers = 0

/**
 * Hook to ensure wait-screen global styles are applied exactly once
 * Lazy-loads styles only when a WaitScreen component is actually used.
 * Cleans up the injected global style tag when no WaitScreen is mounted.
 */
export const useWaitScreenStyles = () => {
  useEffect(() => {
    activeConsumers += 1

    if (!stylesApplied) {
      applyGlobalStyles()
      stylesApplied = true
    }

    return () => {
      activeConsumers = Math.max(0, activeConsumers - 1)

      if (activeConsumers === 0) {
        const injectedStyles = document.getElementById('global-styles')
        if (injectedStyles && injectedStyles.parentNode) {
          injectedStyles.parentNode.removeChild(injectedStyles)
        }
        stylesApplied = false
      }
    }
  }, [])
}

export default useWaitScreenStyles
